import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { update as updateSte } from '@/store/slices/steSlice';
import { Brand } from '@/types/Brand';

const useBrand = () => {
  const { brand } = useAppSelector((state) => state.selectedSte);
  const dispatch = useAppDispatch();

  const get = () => {
    if (brand) {
      return brand;
    }
    const brandFromURL = (((
      ((window?.location?.hash ?? '').split('#/') ?? ['', ''])[1] ?? ''
    ).split('/') ?? [''])[0] ?? '') as Brand;
    if (brandFromURL.length > 0) {
      dispatch(updateSte({ brand: brandFromURL }));
    }
    return brandFromURL;
  };

  return {
    get,
  };
};

export default useBrand;
